import { APIConfig } from "../../config/apiConfig";
import moment from "moment";

const formatData = (data) => {
  return data.map((cost) => ({
    _id: cost._id,
    supervisorName: cost.supervisorName || "Nil",
    type: cost.type || "Nil",
    impressAmount: cost.impressAmount,
    split: cost.split,
    month: moment(cost.month).format("MMMM-yyyy"),
    date: moment(cost.date).format("MM/DD/yyyy"),
    dateAdded: moment(cost.createdAt).format("MM/DD/yyyy"),
    createdBy: cost.agentDetails.first_name + " " + cost.agentDetails.last_name,
  }));
};

const state = () => ({
  supervisorImprestCosts: [],
  costsToBeUpdated: {},
  error: null,
});

const getters = {
  getCostsToBeUpdated: (state) => state.costsToBeUpdated,
};

const mutations = {
  populateSupervisorImprestCosts(state, supervisorImprestCosts) {
    state.supervisorImprestCosts = supervisorImprestCosts;
  },

  setCostsToBeUpdated(state, costs) {
    state.costsToBeUpdated = costs;
  },
};

const actions = {
  findCostToBeUpdated({ commit, state }, costId) {
    let costs = state.supervisorImprestCosts.find(
      (cost) => cost._id === costId
    );

    commit("setCostsToBeUpdated", costs);
  },

  async fetchSupervisorImprestCosts({ commit }, params) {
    const { page, limit } = params;
    try {
      const { data } = await APIConfig.get(
        `/supervisor-impress/?page=${page}&limit=${limit}`
      );

      const supervisorImprestCosts = data?.data ? formatData(data?.data) : [];

      commit("populateSupervisorImprestCosts", supervisorImprestCosts);

      return {
        count: data?.count,
        cost: supervisorImprestCosts,
      };
    } catch (error) {
      console.log(error);
    }
  },

  async addNewCosts(_, payload) {
    try {
      const { data } = await APIConfig.post(`/supervisor-impress`, payload);

      return data;
    } catch (error) {
      console.log(error);
    }
  },

  async filterByDatePeriod({ commit }, params) {
    const { page, limit, filterQuery } = params;
    try {
      const { data } = await APIConfig.get(
        `/supervisor-impress/date-range?page=${page}&limit=${limit}&${filterQuery}`
      );

      if (Object.keys(data).length > 0) {
        const supervisorImprestCosts = formatData(data?.data);

        commit("populateSupervisorImprestCosts", supervisorImprestCosts);

        return {
          count: data?.count,
          cost: supervisorImprestCosts,
        };
      } else {
        return {
          count: 0,
          cost: [],
        };
      }
    } catch (error) {
      console.log(error);
    }
  },

  async createTarget(_, payload) {
    try {
      const { data } = await APIConfig.post(
        `/supervisor-impress/target`,
        payload
      );

      return data;
    } catch (error) {
      console.log(error);
    }
  },

  async updateCosts(_, payload) {
    try {
      const { data } = await APIConfig.patch(
        `/supervisor-impress/${payload.id}`,
        payload
      );

      return data;
    } catch (error) {
      console.log(error);
    }
  },

  async deleteCosts(_, id) {
    try {
      const { data } = await APIConfig.delete(`/supervisor-impress/${id}`);

      return data;
    } catch (error) {
      console.log(error);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
